import { render, staticRenderFns } from "./approveTypeDialog.vue?vue&type=template&id=7676396c&scoped=true&"
import script from "./approveTypeDialog.vue?vue&type=script&lang=js&"
export * from "./approveTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./approveTypeDialog.vue?vue&type=style&index=0&id=7676396c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7676396c",
  null
  
)

export default component.exports